/* eslint-disable @typescript-eslint/no-empty-function */

export const trace = !import.meta.env.PROD ? (...args) => console.log('[src/index]', ...args) : () => {};
